import appTooltipId from './appTooltipId';

//
// Spread onto any element to give it the app tooltip. Passing no text yields no
// attributes at all, so call sites need no conditional of their own.
//
const appTooltipProps = (text, place) => (
  (!text)
    ? {}
    : {
        'data-tooltip-id': appTooltipId,
        'data-tooltip-content': text,
        ...(place && { 'data-tooltip-place': place }),
      });

export default appTooltipProps;
